var _defs, _path, _g, _g2, _path2, _g3, _g4, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterInspectorMode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 674,
    height: 247,
    viewBox: "0 0 674 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.s,.w,.x{fill:none}.b{fill:#eee}.c{clip-path:url(#a)}.d{fill:url(#b)}.e{clip-path:url(#c)}.f{fill:url(#d)}.g,.m{fill:#1d1d1b}.h{fill:#fafafc}.i{fill:#ccc}.j{fill:#999}.k{fill:url(#e)}.l{opacity:.2}.m{opacity:.8}.n{fill:#3c3c3b}.o{fill:url(#f)}.p{fill:#fff}.q{fill:#f3f3f3}.r{fill:#5a5a5a}.s{stroke:#fff;stroke-linecap:square;stroke-width:1.3564px}.s,.w{stroke-miterlimit:10}.t{fill:#ffec00}.u{clip-path:url(#g)}.v{clip-path:url(#h)}.w,.x{stroke:#000;stroke-width:3px}.x{stroke-linecap:round;stroke-linejoin:round}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0 0h674v247H0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 337,
    cy: 143.5,
    r: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-706 0h674v247h-674z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 236.662,
    y1: -583.054,
    x2: 699.087,
    y2: 182.31,
    gradientTransform: "rotate(-90 337.424 401.557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#696a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#606166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#434549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#323437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#2c2e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#323437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#424447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5d5e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696a6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 219.828,
    y1: -312.36,
    x2: 689.004,
    y2: -98.868,
    gradientTransform: "rotate(-90 337.424 401.557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3a3b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#252524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -264.453,
    y1: 521.791,
    x2: -264.453,
    y2: 20.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M706 0h674v247H706z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: -137.806,
    cy: 429.552,
    r: 80
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Help-Card-Screenshot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0 0h674v247H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 337,
    cy: 143.5,
    r: 155
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M91.382 22.793c9.525-.952 10.565-2.793 17.732-2.793 16.215 0 47.98 24.654 47.98 48.047 0 17.131-3.571 1.488-3.571 47.819l-.223-.273v310.964l.223-.273c0 46.33 3.57 30.687 3.57 47.819 0 23.393-31.764 48.047-47.979 48.047-7.176 0-8.212-1.846-17.78-2.798H-620.24c-9.573.952-10.604 2.798-17.781 2.798-16.219 0-47.979-24.654-47.979-48.047 0-17.132 3.57-1.488 3.57-47.819l.224.273V115.593l-.223.273c0-46.33-3.571-30.688-3.571-47.82C-686 44.655-654.24 20-638.02 20c7.162 0 8.202 1.841 17.731 2.793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M109.114 20.337c7.902 0 19.895 6.094 29.843 15.163 11.312 10.313 17.799 22.175 17.799 32.547 0 6.43-.5 8.185-1.133 10.405-1.028 3.61-2.438 8.555-2.438 37.414v310.418c0 28.858 1.41 33.803 2.438 37.413.633 2.221 1.133 3.975 1.133 10.406 0 10.371-6.487 22.234-17.799 32.546-9.948 9.07-21.94 15.163-29.843 15.163a29.635 29.635 0 0 1-8.312-1.13 58.854 58.854 0 0 0-9.469-1.668l-711.606.002a58.829 58.829 0 0 0-9.439 1.666 29.619 29.619 0 0 1-8.309 1.13c-7.903 0-19.897-6.093-29.844-15.163-11.31-10.312-17.797-22.174-17.797-32.546 0-6.431.5-8.185 1.132-10.406 1.029-3.61 2.438-8.555 2.438-37.413V115.866c0-28.858-1.409-33.803-2.438-37.414-.633-2.22-1.132-3.974-1.132-10.405 0-10.372 6.486-22.235 17.797-32.547 9.947-9.069 21.94-15.162 29.844-15.162a29.593 29.593 0 0 1 8.306 1.13 58.716 58.716 0 0 0 9.426 1.663l711.705-.002a58.702 58.702 0 0 0 9.387-1.66 29.605 29.605 0 0 1 8.311-1.131m0-.338c-7.167 0-8.207 1.842-17.732 2.794h-711.67c-9.53-.953-10.57-2.794-17.733-2.794C-654.24 20-686 44.654-686 68.047c0 17.131 3.57 1.488 3.57 47.819v310.418c0 46.33-3.57 30.687-3.57 47.819 0 23.393 31.76 48.047 47.98 48.047 7.176 0 8.207-1.846 17.78-2.798H91.333c9.57.952 10.605 2.798 17.781 2.798 16.215 0 47.98-24.654 47.98-48.047 0-17.132-3.571-1.488-3.571-47.819V115.866c0-46.33 3.57-30.688 3.57-47.82C157.094 44.655 125.33 20 109.115 20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M92.734 33.322a50.445 50.445 0 0 1 50.388 50.388v374.73a50.445 50.445 0 0 1-50.388 50.388H-621.64a50.445 50.445 0 0 1-50.389-50.388V83.71a50.445 50.445 0 0 1 50.389-50.388H92.734m0-4.22H-621.64a54.608 54.608 0 0 0-54.608 54.608v374.73a54.608 54.608 0 0 0 54.608 54.607H92.734a54.608 54.608 0 0 0 54.607-54.607V83.71a54.608 54.608 0 0 0-54.607-54.607z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M92.734 29.102A54.608 54.608 0 0 1 147.34 83.71v374.73a54.608 54.608 0 0 1-54.607 54.608H-621.64a54.608 54.608 0 0 1-54.608-54.608V83.71a54.608 54.608 0 0 1 54.608-54.607H92.734m0-.844H-621.64a55.514 55.514 0 0 0-55.452 55.451v374.73a55.514 55.514 0 0 0 55.452 55.451H92.734a55.514 55.514 0 0 0 55.451-55.451V83.71a55.514 55.514 0 0 0-55.451-55.451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.695 31.212a53.597 53.597 0 0 1 53.537 53.537v372.652a53.597 53.597 0 0 1-53.537 53.536h-712.296a53.597 53.597 0 0 1-53.537-53.536V84.749a53.597 53.597 0 0 1 53.537-53.537H91.695m0-.844h-712.296a54.38 54.38 0 0 0-54.381 54.381v372.652a54.38 54.38 0 0 0 54.38 54.38H91.696a54.38 54.38 0 0 0 54.38-54.38V84.749a54.38 54.38 0 0 0-54.38-54.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M91.175 31.845A53.484 53.484 0 0 1 144.6 85.27v371.61a53.484 53.484 0 0 1-53.424 53.424h-711.257a53.484 53.484 0 0 1-53.423-53.424V85.27a53.484 53.484 0 0 1 53.423-53.424H91.175m0-.844h-711.257a54.267 54.267 0 0 0-54.267 54.268v371.61a54.267 54.267 0 0 0 54.267 54.268H91.175a54.267 54.267 0 0 0 54.268-54.268V85.27A54.267 54.267 0 0 0 91.175 31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91.508 32.228a52.855 52.855 0 0 1 52.796 52.795v372.103a52.855 52.855 0 0 1-52.796 52.796h-711.922a52.855 52.855 0 0 1-52.796-52.796V85.024a52.855 52.855 0 0 1 52.796-52.796H91.508m0-.506h-711.922a53.302 53.302 0 0 0-53.302 53.302v372.102a53.302 53.302 0 0 0 53.302 53.302H91.508a53.302 53.302 0 0 0 53.302-53.302V85.024a53.302 53.302 0 0 0-53.302-53.302z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: -672.029,
    y: 32.988,
    width: 816.838,
    height: 476.175,
    rx: 51.474,
    ry: 51.474
  }), /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M93.335 36.363a48.154 48.154 0 0 1 48.1 48.099v373.226a48.154 48.154 0 0 1-48.1 48.099h-713.89a48.153 48.153 0 0 1-48.099-48.1V84.463a48.154 48.154 0 0 1 48.1-48.099h713.89m0-3.375h-713.89a51.474 51.474 0 0 0-51.475 51.474v373.226a51.474 51.474 0 0 0 51.475 51.474h713.89a51.474 51.474 0 0 0 51.474-51.474V84.462a51.474 51.474 0 0 0-51.475-51.474z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: -479.681,
    y: -73.212,
    width: 434.578,
    height: 688.574,
    rx: 3.375,
    ry: 3.375,
    transform: "rotate(-90 -262.392 271.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-604.57 486.254V55.895H79.785v430.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M108.796 20.696c7.896 0 19.878 6.085 29.818 15.141 11.301 10.298 17.783 22.143 17.783 32.5 0 6.422-.499 8.173-1.131 10.39-1.028 3.606-2.436 8.544-2.436 37.36v309.975c0 28.817 1.408 33.755 2.436 37.36.632 2.218 1.131 3.97 1.131 10.39 0 10.357-6.481 22.203-17.783 32.5-9.94 9.057-21.922 15.142-29.818 15.142a29.625 29.625 0 0 1-8.305-1.13 58.826 58.826 0 0 0-9.461-1.664l-711 .002a58.804 58.804 0 0 0-9.431 1.663 29.604 29.604 0 0 1-8.302 1.129c-7.897 0-19.88-6.085-29.82-15.141-11.3-10.297-17.781-22.143-17.781-32.5 0-6.422.5-8.173 1.132-10.39 1.028-3.606 2.435-8.544 2.435-37.36V116.086c0-28.817-1.407-33.754-2.435-37.36-.633-2.217-1.132-3.969-1.132-10.39 0-10.357 6.481-22.202 17.782-32.5 9.939-9.056 21.922-15.141 29.819-15.141a29.582 29.582 0 0 1 8.298 1.129 58.706 58.706 0 0 0 9.419 1.66l711.099-.001a58.677 58.677 0 0 0 9.38-1.658 29.598 29.598 0 0 1 8.304-1.13m0-.338c-7.162 0-8.201 1.84-17.717 2.79h-711.066c-9.52-.95-10.56-2.79-17.717-2.79-16.205 0-47.938 24.619-47.938 47.979 0 17.107 3.567 1.486 3.567 47.75v309.975c0 46.265-3.567 30.644-3.567 47.75 0 23.36 31.733 47.979 47.938 47.979 7.17 0 8.2-1.843 17.766-2.794H91.03c9.561.95 10.596 2.794 17.766 2.794 16.201 0 47.938-24.618 47.938-47.978 0-17.107-3.567-1.486-3.567-47.75V116.086c0-46.264 3.567-30.643 3.567-47.75 0-23.36-31.737-47.978-47.938-47.978z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-604.57 486.254V55.895H79.785v430.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M-593.665 230.865H231v42.047h-824.665zm152.59-174.97H231V121h-672.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.386 98.532a7.09 7.09 0 0 1 0-2.214 1.244 1.244 0 0 1 1.247-.835 1.243 1.243 0 0 1 1.248.835 7.09 7.09 0 0 1 0 2.214 1.244 1.244 0 0 1-1.248.835 1.244 1.244 0 0 1-1.247-.835zm1.833-.174a3.565 3.565 0 0 0 .054-.933 3.567 3.567 0 0 0-.054-.933.574.574 0 0 0-.586-.38.573.573 0 0 0-.585.38 7.984 7.984 0 0 0 0 1.866.573.573 0 0 0 .585.38.574.574 0 0 0 .586-.38zm3.255-2.799a.176.176 0 0 1 .173-.108h.521c.065 0 .087.054.055.108l-4.286 7.399a.17.17 0 0 1-.163.108h-.52a.069.069 0 0 1-.066-.108zm-1.03 5.544a3.208 3.208 0 0 1 .086-1.107 1.243 1.243 0 0 1 1.248-.835 1.244 1.244 0 0 1 1.247.835 7.09 7.09 0 0 1 0 2.214 1.244 1.244 0 0 1-1.247.835 1.244 1.244 0 0 1-1.248-.836 3.202 3.202 0 0 1-.087-1.106zm1.334 1.313a.573.573 0 0 0 .586-.38 8.06 8.06 0 0 0 0-1.866.574.574 0 0 0-.586-.38.574.574 0 0 0-.586.38 8.06 8.06 0 0 0 0 1.866.573.573 0 0 0 .586.38zm3.679-3.027a10.033 10.033 0 0 0-1.03-4.362c-.033-.065 0-.108.064-.108h.38a.198.198 0 0 1 .174.108 8.012 8.012 0 0 1 0 8.723.197.197 0 0 1-.174.109h-.38c-.065 0-.098-.043-.065-.109a10.111 10.111 0 0 0 1.031-4.361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M-450.569 207.807H231v21.702h-681.569z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M133.633 207.807v84.773m-97.367-84.773v84.773"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M401 187.5H273v-128h128z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M624.127 222.856h719.113v71.222H624.127zm0-73.519h719.113v71.222H624.127zm0-73.52h719.113v71.222H624.127z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M621.829 36.76h721.411v36.76H621.829z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "v"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-274.056 58.3h366.25v631.05h-366.25z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M351.74 153.5H297v-60h80v51.52m-40 8.48v-8m0-44v-8m-22 30h-18m80 0h-18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M386.918 160.837s.082-9.677.082-10.712a2.472 2.472 0 0 0-2.699-2.468h-2.988a2.64 2.64 0 0 0-2.889-2.643h-3.4a2.683 2.683 0 0 0-2.807-2.567h-3.763v-9.103c0-3.7-7-4.455-7 0v19.41s-3.27-1.842-5.978-3.321-6.405.075-4.16 3.503 7.416 3.836 10.094 15.299 25.508 15.634 25.508-7.398zm-18.464-18.39v8.559m6.57.182v-6.174m6.289 8.409v-5.766"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.16 128.92v-.661a5.37 5.37 0 0 1 1.216-3.647l2.714-3.728c1.42-1.946 1.906-2.878 1.906-4.255a3.64 3.64 0 0 0-3.93-3.768c-2.27 0-3.729 1.378-4.216 3.849a.356.356 0 0 1-.445.325l-2.553-.446a.357.357 0 0 1-.324-.447 7.254 7.254 0 0 1 7.616-6.442c4.379 0 7.335 2.878 7.335 6.889 0 1.944-.687 3.363-2.066 5.268l-2.715 3.727a4.177 4.177 0 0 0-1.053 3.04v.296a.383.383 0 0 1-.405.406h-2.675a.383.383 0 0 1-.406-.406zm-.203 4.89a.383.383 0 0 1 .405-.405h3.08a.383.383 0 0 1 .405.405v3.484a.383.383 0 0 1-.405.406h-3.08a.383.383 0 0 1-.405-.406z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M273 59.5h128v128H273z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterInspectorMode);
export default __webpack_public_path__ + "static/media/enter-inspector-mode.fe3513520b16f86c4e5fa1b5a39a4158.svg";
export { ForwardRef as ReactComponent };